import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { confirmEmail, errorDetail } from "@/lib/reader";

export default function AccountVerify() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading" });
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) return setState({ status: "error", message: "This link is incomplete." });
    confirmEmail(token)
      .then((r) => setState({ status: "ok", ...r }))
      .catch((e) => setState({ status: "error", message: errorDetail(e) }));
  }, [params]);

  return (
    <div className="pt-32 pb-24 px-6 max-w-xl mx-auto" data-testid="account-verify-page">
      <p className="flex items-center gap-2 font-mono-ui text-xs uppercase tracking-[0.25em] text-primary-gold"><MailCheck className="w-4 h-4" /> Your account</p>
      {state.status === "loading" && <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 text-primary-gold animate-spin" /></div>}
      {state.status === "ok" && (
        <>
          <h1 className="font-serif-display text-4xl sm:text-5xl mt-4" data-testid="account-verify-success">{state.changed ? "Email changed" : "Email verified"}</h1>
          <p className="text-soft mt-4">{state.changed ? `Your account email is now ${state.email}. Use it next time you sign in.` : `Thanks — ${state.email} is confirmed.`}</p>
        </>
      )}
      {state.status === "error" && (
        <>
          <h1 className="font-serif-display text-4xl sm:text-5xl mt-4">Link not valid</h1>
          <p className="text-soft mt-4" data-testid="account-verify-error">{state.message}</p>
        </>
      )}
      {state.status !== "loading" && (
        <Link to="/account" data-testid="account-verify-continue" className="btn-gold inline-block mt-8 px-8 py-4 font-mono-ui text-xs uppercase tracking-[0.18em]">Go to my account</Link>
      )}
    </div>
  );
}
